// extracted by mini-css-extract-plugin
export default {"modal":"ModalWrapper_modal__qS4ga","modal_container":"ModalWrapper_modal_container__sE6cc"};